import { matchPath } from 'react-router-dom'

export const screenRoutes = [
  { path: '/', title: null },
  { path: '/collection', title: 'Collection' },
  { path: '/log/:wearLogId/compliments', title: 'Compliments' },
  { path: '/log', title: 'Today' },
  { path: '/layering', title: 'Layering' },
  { path: '/explore', title: 'Explore' },
  { path: '/stats', title: 'Insights' },
  { path: '/profile', title: 'Account' },
  { path: '/rotation', title: 'Rotation' },
  { path: '/import', title: 'Bulk Import' },
  { path: '/fragrance/:id/log', title: 'Your log' },
  { path: '/fragrance/:id', title: data => data?.name || 'Fragrance' },
  { path: '/reset-password', title: 'Reset Password' },
]

// Screens where the header's "+ Add bottles" shortcut does not belong: Collection and
// Today carry their own add action; Rob ruled it off Rotation and Layering (2026-09-30)
// and off a bottle's log, where the collector is entering memories (2026-10-01).
export const HEADER_ADD_HIDDEN_ROUTES = Object.freeze(['/log', '/collection', '/rotation', '/layering', '/fragrance/:id/log'])

// Route matching, not string equality: React Router renders /layering/ as /layering,
// so a trailing slash must not bring the header shortcut back.
export function headerAddHidden(pathname) {
  return HEADER_ADD_HIDDEN_ROUTES.some(path => matchPath({ path, end: true }, pathname))
}

export function resolveRouteTitle(pathname, data) {
  const route = screenRoutes.find(route => matchPath(route.path, pathname))
  return typeof route?.title === 'function' ? route.title(data) : route?.title ?? (pathname === '/' ? null : 'FragranceOS')
}
